// // import { useEffect, useState } from "react";
// // // import { postData } from "../global/Globalapi";
// // import { postData } from "../../../global/Globalapi";

// // function PopupPage() {
// //   const params = new URLSearchParams(window.location.search);

// //   const campaign_id = params.get("campaign_id");
// //   const affiliate_user_id = params.get("affiliate_user_id");
// //   const redirect_url = params.get("redirect_url");

// //   const [loading, setLoading] = useState(false);
// //   const [createdId, setCreatedId] = useState(null);

// //   const handleActivate = async () => {
// //     try {
// //       setLoading(true);

// //       const res = await postData("/api/affiliateCampaign/join", {
// //         campaign_id,
// //         affiliate_user_id
// //       });

// //       if (res.success) {
// //         setCreatedId(res.affiliate_campaign_id);

// //         // Save ID for next steps
// //         setTimeout(() => {
// //           window.location.href = redirect_url;
// //         }, 1200);
// //       }

// //     } catch (err) {
// //       console.error("Activation Error", err);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <div style={{ padding: "20px" }}>
// //       <h2>Activate Your Campaign</h2>
// //       <p>Click below to activate this campaign and continue.</p>

// //       {!createdId && (
// //         <button
// //           onClick={handleActivate}
// //           disabled={loading}
// //           style={{
// //             padding: "10px 20px",
// //             background: "green",
// //             color: "white",
// //             borderRadius: "6px",
// //             cursor: "pointer"
// //           }}
// //         >
// //           {loading ? "Activating..." : "Activate Campaign"}
// //         </button>
// //       )}

// //       {createdId && (
// //         <p style={{ color: "green" }}>
// //           Campaign activated! Redirecting...
// //         </p>
// //       )}
// //     </div>
// //   );
// // }

// // export default PopupPage;
// import React, { useState } from "react";
// import PopupWrapper from "./PopupWrapper";
// // import { postData } from "../global/Globalapi";
// import { postData } from "../../../global/Globalapi";
// function AffiliateCampaignInvite({ campaign, onClose }) {
//   const [copied, setCopied] = useState(false);
//   const [activated, setActivated] = useState(false);
//   const [generatedUrl, setGeneratedUrl] = useState("");

//   if (!campaign) {
//     return (
//       <PopupWrapper onClose={onClose}>
//         <div style={{ padding: "20px", textAlign: "center" }}>
//           <h5>No campaign data found.</h5>
//         </div>
//       </PopupWrapper>
//     );
//   }

//   const {
//     campaign_name,
//     description,
//     commission,
//     target_url,
//     campaign_id,
//     affiliate_user_id,
//     affiliated_campaign_id,
//   } = campaign;

//   const affiliateId = affiliate_user_id || localStorage.getItem("usertypeid");

//   const handleActivate = async () => {
//     try {
//       const res = await postData("/api/affiliateCampaign/join", {
//         campaign_id,
//         affiliate_user_id: affiliateId,
//       });

//       if (res.success) {
//         const newAffiliateCampaignId = res.affiliate_campaign_id;

//         // generate URL only after activation
//         const url = `${target_url}?campaign_id=${btoa(
//           String(campaign_id)
//         )}&affiliate_user_id=${btoa(
//           String(affiliateId)
//         )}&affiliated_campaign_id=${btoa(String(newAffiliateCampaignId))}`;

//         setGeneratedUrl(url);
//         setActivated(true);
//       }
//     } catch (error) {
//       console.error("Activation failed", error);
//     }
//   };

//   const handleCopy = () => {
//     navigator.clipboard.writeText(generatedUrl);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 1500);
//   };

//   return (
//     <PopupWrapper onClose={onClose}>
//       <div
//         style={{
//           fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//           backgroundColor: "#f8f9fa",
//           padding: "30px 40px",
//           position: "relative",
//         }}
//       >
//         {/* Close button */}
//         <button
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             top: "20px",
//             right: "20px",
//             background: "transparent",
//             border: "none",
//             fontSize: "22px",
//             color: "#333",
//             cursor: "pointer",
//           }}
//         >
//           Close
//         </button>

//         <div style={{ textAlign: "center", marginTop: "10px" }}>
//           <h2
//             style={{
//               display: "inline-block",
//               background: "#000",
//               color: "#fff",
//               padding: "10px 25px",
//               borderRadius: "5px",
//               fontSize: "20px",
//             }}
//           >
//             Brand Logo
//           </h2>
//         </div>

//         <div style={{ marginTop: "35px", textAlign: "center" }}>
//           <h2 style={{ fontWeight: "700", fontSize: "24px", color: "#222" }}>
//             Join Our New Affiliate Campaign
//           </h2>

//           <p style={{ color: "#555", marginTop: "10px", marginBottom: "20px" }}>
//             Hello Partner,
//           </p>

//           <p
//             style={{
//               color: "#555",
//               lineHeight: "1.8",
//               fontSize: "15.5px",
//               marginBottom: "25px",
//             }}
//           >
//             We’re thrilled to invite you to participate in our latest affiliate
//             campaign:
//             <strong> {campaign_name}</strong>.
//           </p>

//           {/* Show Activate button first */}
//           {!activated && (
//             <button
//               onClick={handleActivate}
//               style={{
//                 backgroundColor: "#28a745",
//                 color: "#fff",
//                 padding: "12px 26px",
//                 borderRadius: "5px",
//                 border: "none",
//                 fontWeight: "600",
//                 fontSize: "16px",
//                 cursor: "pointer",
//                 marginTop: "15px",
//               }}
//             >
//               Activate Campaign
//             </button>
//           )}

//           {/* After activation → show URL + Copy button */}
//           {activated && (
//             <div
//               style={{
//                 backgroundColor: "#e9ecef",
//                 marginTop: "30px",
//                 padding: "15px",
//                 borderRadius: "6px",
//                 fontSize: "13.5px",
//                 color: "#333",
//                 wordBreak: "break-all",
//                 border: "1px solid #d6d8db",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 gap: "10px",
//               }}
//             >
//               <span style={{ fontFamily: "monospace", flex: 1 }}>
//                 {generatedUrl}
//               </span>
//               <button
//                 onClick={handleCopy}
//                 style={{
//                   backgroundColor: copied ? "#28a745" : "#007bff",
//                   color: "#fff",
//                   border: "none",
//                   padding: "6px 10px",
//                   borderRadius: "4px",
//                   fontSize: "13px",
//                   cursor: "pointer",
//                   minWidth: "90px",
//                 }}
//               >
//                 {copied ? "Copied!" : "Copy URL"}
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </PopupWrapper>
//   );
// }

// // export default AffiliateCampaignInvite;
// import React, { useState } from "react";
// import PopupWrapper from "./PopupWrapper";
// import { postData } from "../../../global/Globalapi";

// function PopupPage() {
//   const params = new URLSearchParams(window.location.search);

//   const encodedCampaignId = params.get("campaign_id");
//   const encodedUserId = params.get("affiliate_user_id");
//   const redirect_url = params.get("redirect_url") || "";

//   // Decode Base64 values
//   const campaign_id = atob(encodedCampaignId || "");
//   const affiliate_user_id = atob(encodedUserId || "");

//   const [loading, setLoading] = useState(false);
//   const [activated, setActivated] = useState(false);

//   const handleActivate = async () => {
//     try {
//       setLoading(true);

//       const res = await postData("/api/affiliateCampaign/join", {
//         campaign_id,
//         affiliate_user_id,
//       });

//       if (res.success) {
//         setActivated(true);

//         setTimeout(() => {
//           window.location.href = redirect_url;
//         }, 1200);
//       }
//     } catch (err) {
//       console.error("Activation Error", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <PopupWrapper>
//       <div style={{ padding: "20px", textAlign: "center" }}>
//         <h2>Activate Your Campaign</h2>
//         <p>Your affiliate invitation is ready.</p>
//         {/* <p>
//           <strong>Campaign ID:</strong> {campaign_id}
//         </p>
//         <p>
//           <strong>User ID:</strong> {affiliate_user_id}
//         </p> */}

//         {!activated && (
//           <button
//             onClick={handleActivate}
//             disabled={loading}
//             style={{
//               padding: "10px 20px",
//               background: "green",
//               color: "white",
//               borderRadius: "6px",
//               cursor: "pointer",
//               marginTop: "15px",
//             }}
//           >
//             {loading ? "Activating..." : "Activate Campaign"}
//           </button>
//         )}

//         {activated && (
//           <p style={{ color: "green" }}>Campaign activated! Redirecting...</p>
//         )}
//       </div>
//     </PopupWrapper>
//   );
// }

// export default PopupPage;
// import { useEffect, useState } from "react";
// import { postData } from "../../../global/Globalapi";

// function PopupPage() {
//   const params = new URLSearchParams(window.location.search);

//   // Read encoded params
//   const encodedCampaign = params.get("campaign_id");
//   const encodedUser = params.get("affiliate_user_id");
//   const redirect_url = params.get("redirect_url") || "";

//   // Decode to original numeric values
//   const campaign_id = encodedCampaign ? Number(atob(encodedCampaign)) : null;
//   const affiliate_user_id = encodedUser ? Number(atob(encodedUser)) : null;

//   const [activated, setActivated] = useState(false);
//   const [generatedUrl, setGeneratedUrl] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleActivate = async () => {
//     try {
//       setLoading(true);

//       const res = await postData("/affiliateCampaign/join", {
//         campaign_id,
//         affiliate_user_id
//       });

//       if (res.success) {
//         const affiliate_campaign_id = res.affiliate_campaign_id;

//         // Generate final sharable URL
//         const url =
//           `${redirect_url}?campaign_id=${btoa(String(campaign_id))}` +
//           `&affiliate_user_id=${btoa(String(affiliate_user_id))}` +
//           `&affiliate_campaign_id=${btoa(String(affiliate_campaign_id))}`;

//         setGeneratedUrl(url);
//         setActivated(true);
//       }

//     } catch (error) {
//       console.error("Activation Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const copyUrl = () => {
//     navigator.clipboard.writeText(generatedUrl);
//     alert("Copied!");
//   };

//   return (
//     <div style={{ padding: "40px", textAlign: "center" }}>
//       <h2>Activate Your Affiliate Campaign</h2>

//       <p>Click the button below to activate your campaign.</p>

//       {/* Before activation */}
//       {!activated && (
//         <button
//           onClick={handleActivate}
//           disabled={loading}
//           style={{
//             background: "green",
//             padding: "10px 22px",
//             color: "white",
//             borderRadius: "6px",
//             cursor: "pointer"
//           }}
//         >
//           {loading ? "Activating..." : "Activate Campaign"}
//         </button>
//       )}

//       {/* After activation */}
//       {activated && (
//         <>
//           <p style={{ marginTop: "20px", fontWeight: "bold" }}>Your Affiliate Link:</p>
//           <div
//             style={{
//               background: "#eee",
//               padding: "10px",
//               borderRadius: "5px",
//               wordBreak: "break-all"
//             }}
//           >
//             {generatedUrl}
//           </div>

//           <button
//             onClick={copyUrl}
//             style={{
//               marginTop: "15px",
//               background: "#007bff",
//               padding: "8px 16px",
//               color: "white",
//               borderRadius: "5px",
//               cursor: "pointer"
//             }}
//           >
//             Copy URL
//           </button>
//         </>
//       )}
//     </div>
//   );
// }

// export default PopupPage;
import { useEffect, useState } from "react";
import { postData } from "../../../global/Globalapi";

function PopupPage() {
  const params = new URLSearchParams(window.location.search);

  const encodedCampaign = params.get("campaign_id");
  const encodedUser = params.get("affiliate_user_id");
  const redirect_url = params.get("redirect_url") || "";
  const product_url = params.get("product_url") || ""; // NEW

  const campaign_id = encodedCampaign ? Number(atob(encodedCampaign)) : null;
  const affiliate_user_id = encodedUser ? Number(atob(encodedUser)) : null;

  const [activated, setActivated] = useState(false);
  const [generatedUrl, setGeneratedUrl] = useState("");
  const [loading, setLoading] = useState(false);

  // Static UI content (replace when needed)
  const campaignName = params.get("name") || "Affiliate Campaign";
  const commission = params.get("commission") || "N/A";

  // const handleActivate = async () => {
  //   try {
  //     setLoading(true);

  //     const res = await postData("/affiliateCampaign/join", {
  //       campaign_id,
  //       affiliate_user_id,
  //     });
  //   console.log("ACTIVATE RESPONSE:", res.data);  // Debug
  //     // if (res.success) {
  //     //   const affiliate_campaign_id = res.affiliate_campaign_id;
  //     if (res.data?.success) {
  // const affiliate_campaign_id = res.data.affiliate_campaign_id;


  //       const url =
  //         `${product_url}?campaign_id=${btoa(String(campaign_id))}` +
  //         `&affiliate_user_id=${btoa(String(affiliate_user_id))}` +
  //         `&affiliate_campaign_id=${btoa(String(affiliate_campaign_id))}`;

  //       setGeneratedUrl(url);
  //       setActivated(true);
  //     }
  //   } catch (error) {
  //     console.error("Activation Error:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
const handleActivate = async () => {
  try {
    setLoading(true);

    const res = await postData("/affiliateCampaign/join", {
      campaign_id,
      affiliate_user_id,
    });

    // Backend returns affiliated_campaign_id ALWAYS (new or exists)
    // const affiliate_campaign_id =
    //   res.affiliate_campaign_id || res.affiliated_campaign_id;

    // if (affiliate_campaign_id) {
    //   // generate URL
    //   const url =
    //     `${product_url}?campaign_id=${btoa(String(campaign_id))}` +
    //     `&affiliate_user_id=${btoa(String(affiliate_user_id))}` +
    //     `&affiliate_campaign_id=${btoa(String(affiliate_campaign_id))}`;

    //   setGeneratedUrl(url);
    //   setActivated(true);
    // }
 console.log("ACTIVATE RESPONSE:", res);

    // backend returns:
    // { status: "new" | "exists", affiliate_user_id, campaign_id, affiliated_campaign_id }

    // const affiliate_campaign_id = res.affiliated_campaign_id;
      const affiliate_campaign_id = res.data?.affiliated_campaign_id;

    // if (affiliate_campaign_id) {
    if (res.data?.status === "new" || res.data?.status === "exists") {

      // Mark UI as activated immediately
      setActivated(true);

      // Generate final affiliate link
      const url =
        `${redirect_url}?campaign_id=${btoa(String(campaign_id))}` +
        `&affiliate_user_id=${btoa(String(affiliate_user_id))}` +
        `&affiliated_campaign_id=${btoa(String(affiliate_campaign_id))}`;

      setGeneratedUrl(url);
    }
  } catch (error) {
    console.error("Activation Error:", error);
  } finally {
    setLoading(false);
  }
};

  const copyUrl = () => {
    navigator.clipboard.writeText(generatedUrl);
    alert("Copied!");
  };

  return (
    <div
      style={{
        maxWidth: "650px",
        margin: "50px auto",
        padding: "40px",
        background: "white",
        borderRadius: "10px",
        boxShadow: "0 5px 20px rgba(0,0,0,0.15)",
        fontFamily: "Segoe UI",
      }}
    >
      {/* LOGO */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <h3
          style={{
            background: "#000",
            color: "#fff",
            padding: "10px 25px",
            display: "inline-block",
            borderRadius: "6px",
          }}
        >
          Brand Logo
        </h3>
      </div>

      {/* Header */}
      <h2
        style={{
          textAlign: "center",
          fontWeight: "700",
          fontSize: "24px",
          marginBottom: "15px",
        }}
      >
        Join Our New Affiliate Campaign
      </h2>

      <p style={{ textAlign: "center", color: "#444" }}>Hello Partner,</p>

      <p
        style={{
          textAlign: "center",
          color: "#555",
          maxWidth: "520px",
          margin: "10px auto 25px auto",
          lineHeight: "1.6",
        }}
      >
        We’re thrilled to invite you to participate in our latest affiliate
        campaign: <strong>{campaignName}</strong>. This program helps you grow
        your earnings while promoting products your audience will love.
      </p>

      {/* Features */}
      <div
        style={{
          maxWidth: "450px",
          margin: "0 auto 25px auto",
          color: "#333",
          fontSize: "15px",
        }}
      >
        <p>✔ Earn up to <strong>{commission}</strong> commission per referral</p>
        <p>✔ Access exclusive creative assets and tracking tools</p>
        <p>✔ Get performance insights and timely payouts</p>
      </div>

      <p
        style={{
          textAlign: "center",
          fontStyle: "italic",
          color: "#777",
          marginBottom: "35px",
        }}
      >
        “Standard Affiliate Broadcast”
      </p>

      {/* BEFORE ACTIVATION */}
      {!activated && (
        <div style={{ textAlign: "center" }}>
          <button
            onClick={handleActivate}
            disabled={loading}
            style={{
              background: "#0d6efd",
              color: "white",
              padding: "12px 28px",
              borderRadius: "6px",
              fontSize: "16px",
              border: "none",
              cursor: "pointer",
            }}
          >
            {loading ? "Activating..." : "Start Campaign"}
          </button>
        </div>
      )}

      {/* AFTER ACTIVATION */}
      {activated && (
        <>
          <div
            style={{
              background: "#eef1f5",
              padding: "15px",
              borderRadius: "8px",
              border: "1px solid #d7dce2",
              marginBottom: "15px",
              wordBreak: "break-all",
            }}
          >
            {generatedUrl}
          </div>

          <div style={{ textAlign: "center" }}>
            <button
              onClick={copyUrl}
              style={{
                background: "#198754",
                color: "white",
                padding: "10px 20px",
                borderRadius: "5px",
                border: "none",
                cursor: "pointer",
                width: "120px",
              }}
            >
              Copy URL
            </button>
          </div>
        </>
      )}

      {/* FOOTER */}
      <p
        style={{
          textAlign: "center",
          color: "#777",
          marginTop: "30px",
          fontSize: "13px",
        }}
      >
        Have questions? Reach out at <strong>support@example.com</strong>
      </p>
    </div>
  );
}

export default PopupPage;
